<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <emp-role-application-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" :roleId="this.roleId" :roleName="this.roleName" :roleApps="this.roleApps" :roleApplicationCode="this.roleApplicationCode"></emp-role-application-form>
  </j-modal>
</template>

<script>

  import EmpRoleApplicationForm from './EmpRoleApplicationForm'
  export default {
    name: 'EmpRoleApplicationModal',
    components: {
      EmpRoleApplicationForm
    },
    data () {
      return {
        title:'',
        width:1600,
        visible: false,
        disableSubmit: false,
        roleId: '',
        roleName: '',
        roleApps: [],
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      preset (roleId,roleName,roleApps,roleApplicationCode) {
        this.visible = true;
        this.roleId = roleId;
        this.roleName = roleName;
        this.roleApps = roleApps;
        this.roleApplicationCode = roleApplicationCode;
      },
    }
  }
</script>